export const appIcon = {
  CARGO: 'mdi-ferry',
  FIRE: 'mdi-fire',
  MOTOR: 'mdi-car',
  PA: 'mdi-ambulance',
  TRAVEL: 'mdi-plane-shield',
  PACKAGE: 'mdi-animation',
  MAID: 'mdi-broom',
  CURR: 'mdi-currency-usd'
}

export const dri = {
  D: 'Direct',
  R: 'Reinsurance'
}

export const appID = {
  CARGO: 'CA',
  HEALTH: 'HE',
  HULL: 'HU',
  FIRE: 'FI',
  MOTOR: 'MO',
  PA: 'PA',
  TRAVEL: 'TR',
  PACKAGE: 'PK',
  MISC: 'MI',
  MAID: 'MD'
}

export const busClsAppID = {
  CA: 'Cargo',
  HE: 'Health',
  HU: 'Hull',
  FI: 'Fire',
  MO: 'Motor',
  PA: 'Personal Accident',
  TR: 'Travel',
  MI: 'Misc',
  BD: 'Bond'
}

export const appIDDesc = {
  CA: 'Cargo',
  HE: 'Health',
  HU: 'Hull',
  FI: 'Fire',
  MO: 'Motor',
  PA: 'Personal Accident',
  TR: 'Travel',
  PK: 'Package',
  MI: 'Misc',
  MD: 'Maid'
}

export const quoteStatus = {
  NQ: 'Quotation',
  QPA: 'Quotation Pending Approval',
  QA: 'Quotation Approved',
  QD: 'Quotation Declined',
  NP: 'Proposal',
  PPA: 'Proposal Pending Approval',
  PD: 'Proposal Declined',
  IF: 'In-Force',
  PO: 'Policy',
  VO: 'Void',
  NTU: 'Not Taken Up',
  CL: 'Cancellation',
  DC: 'Declined'
}

export const maritalStatus = {
  S: 'Single',
  M: 'Married',
  D: 'Divorced',
  W: 'Widowed',
  P: 'Separated'
}

export const gender = {
  M: 'Male',
  F: 'Female'
}

export const salutation = {
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MDM: 'Mdm',
  DR: 'Dr'
}

export const ccType = {
  MAS: 'Master Card',
  VIS: 'Visa',
  AMEX: 'American Express',
  OTH: 'Others'
}

export const applicantStatus = {
  I: 'Individual',
  E: 'Entity'
}

export const appNationality = {
  SG: 'Singaporean',
  SP: 'Singaporean PR',
  OT: 'Others'
}
